export default __webpack_public_path__ + "static/media/sgìth.6c7f0d8e.mp3";